// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmprojectspg-inline-1 {
  text-align: center;
  padding: 60px 20px;
}

.pmprojectspg-inline-2 {
  margin: 0 auto 20px;
}

.pmprojectspg-inline-3 {
  font-size: 14px;
  color: #64748b;
}

.pmprojectspg-inline-4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.pmprojectspg-inline-5 {
  margin-bottom: 0;
}

.pmprojectspg-inline-6 {
  display: flex;
  gap: 12px;
}

.pmprojectspg-inline-7 {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 12px;
  width: 240px;
}

.pmprojectspg-inline-8 {
  border: none;
  padding: 10px 8px;
  font-size: 13px;
  width: 100%;
  outline: none;
  background: transparent;
}

.pmprojectspg-inline-9 {
  margin-bottom: 16px;
}

.pmprojectspg-inline-10 {
  text-align: center;
  padding: 60px 20px;
}

.pmprojectspg-inline-11 {
  font-size: 48px;
  margin-bottom: 16px;
}

.pmprojectspg-inline-12 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.pmprojectspg-inline-13 {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 24px;
}

.pmprojectspg-inline-14 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.pmprojectspg-inline-15 {
  flex: 1 1;
}

.pmprojectspg-inline-16 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}

.pmprojectspg-inline-17 {
  font-size: 10px;
}

.pmprojectspg-inline-18 {
  font-family: monospace;
}

.pmprojectspg-inline-19 {
  font-size: 12px;
  color: #475569;
  margin-top: 8px;
  max-width: 80%;
}

.pmprojectspg-inline-20 {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pmprojectspg-inline-21 {
  font-size: 11px;
  color: #64748b;
  text-align: right;
}

.pmprojectspg-inline-22 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pmprojectspg-inline-23 {
  width: 100px;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.pmprojectspg-inline-24 {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.pmprojectspg-inline-25 {
  padding: 6px 12px;
  border-color: #fee2e2;
  color: #ef4444;
  background: #fef2f2;
}

.pmprojectspg-inline-26 {
  padding: 8px 16px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pmprojectspg-inline-27 {
  font-weight: 600;
}

.pmprojectspg-inline-28 {
  padding: 0;
  overflow-x: auto;
}

.pmprojectspg-inline-29 {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
}

.pmprojectspg-inline-30 {
  font-family: monospace;
  font-size: 11px;
}

.pmprojectspg-inline-31 {
  font-weight: 600;
}

.pmprojectspg-inline-32 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pmprojectspg-inline-33 {
  width: 60px;
  height: 5px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.pmprojectspg-inline-34 {
  font-size: 11px;
  font-weight: 600;
}

.pmprojectspg-inline-35 {
  display: flex;
  gap: 4px;
}

.pmprojectspg-inline-36 {
  font-size: 10px;
  padding: 3px 8px;
}

.pmprojectspg-inline-37 {
  font-size: 10px;
  padding: 3px 8px;
  border-color: #fee2e2;
  color: #ef4444;
}

.pmprojectspg-inline-38 {
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.pmprojectspg-inline-39 {
  font-size: 12px;
}

.pmprojectspg-inline-40 {
  padding: 12px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.pmprojectspg-inline-41 {
  margin: 0 auto 10px;
}

.pmprojectspg-inline-42 {
  padding: 12px;
}

.pmprojectspg-inline-43 {
  font-size: 12px;
  color: #ef4444;
  margin-top: 8px;
  padding: 12px;
  background: #fef2f2;
  border-radius: 8px;
  border: 1px solid #fee2e2;
}

.pmprojectspg-inline-44 {
  font-size: 11px;
  color: #64748b;
  margin-top: 8px;
}

.pmprojectspg-inline-45 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmprojectspg-inline-46 {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.pmprojectspg-inline-47 {
  font-size: 13px;
  font-weight: 600;
}

.pmprojectspg-inline-48 {
  font-size: 11px;
  color: #64748b;
}

.pmprojectspg-inline-49 {
  padding: 12px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.pmprojectspg-inline-50 {
  margin: 0 auto 10px;
}

.pmprojectspg-inline-51 {
  font-size: 11px;
  color: #64748b;
  margin-top: 8px;
  padding: 8px 12px;
  background: #f1f5f9;
  border-radius: 6px;
}

.pmprojectspg-inline-52 {
  font-weight: 600;
}

.pmprojectspg-inline-53 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmprojectspg-inline-54 {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.pmprojectspg-inline-55 {
  font-size: 13px;
  font-weight: 600;
}

.pmprojectspg-inline-56 {
  font-size: 11px;
  color: #64748b;
}

.pmprojectspg-inline-57 {
  text-align: center;
  margin-top: 4px;
  font-weight: 600;
  font-size: 16px;
}

.pmprojectspg-inline-58 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmprojectspg-inline-59 {
  margin-bottom: 16px;
  padding: 16px;
  background: #fef2f2;
  border-radius: 8px;
  border: 1px solid #fee2e2;
}

.pmprojectspg-inline-60 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.pmprojectspg-inline-61 {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ef4444;
}

.pmprojectspg-inline-62 {
  font-size: 15px;
  font-weight: 700;
}

.pmprojectspg-inline-63 {
  font-size: 11px;
  color: #64748b;
}

.pmprojectspg-inline-64 {
  font-size: 13px;
  color: #b91c1c;
  background: #fff;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #fecaca;
}

.pmprojectspg-inline-65 {
  margin-top: 8px;
  margin-bottom: 0;
  padding-left: 20px;
}

.pmprojectspg-inline-66 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmprojectspg-inline-67 {
  background: #ef4444;
  border-color: #ef4444;
}

.pmprojectspg-dyn-1 {
  height: 100%;
  width: var(--pmprojectspg-1-width);
  background: var(--pmprojectspg-1-background);
  border-radius: 4px;
}

.pmprojectspg-dyn-2 {
  height: 100%;
  width: var(--pmprojectspg-2-width);
  background: var(--pmprojectspg-2-background);
  border-radius: 4px;
}

.pmprojectspg-dyn-3 {
  background: var(--pmprojectspg-3-background);
  color: var(--pmprojectspg-3-color);
  border-color: var(--pmprojectspg-3-border-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMProjectsPg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,gDAAgD;AAClD","sourcesContent":[".pmprojectspg-inline-1 {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.pmprojectspg-inline-2 {\n  margin: 0 auto 20px;\n}\n\n.pmprojectspg-inline-3 {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pmprojectspg-inline-4 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.pmprojectspg-inline-5 {\n  margin-bottom: 0;\n}\n\n.pmprojectspg-inline-6 {\n  display: flex;\n  gap: 12px;\n}\n\n.pmprojectspg-inline-7 {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 0 12px;\n  width: 240px;\n}\n\n.pmprojectspg-inline-8 {\n  border: none;\n  padding: 10px 8px;\n  font-size: 13px;\n  width: 100%;\n  outline: none;\n  background: transparent;\n}\n\n.pmprojectspg-inline-9 {\n  margin-bottom: 16px;\n}\n\n.pmprojectspg-inline-10 {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.pmprojectspg-inline-11 {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.pmprojectspg-inline-12 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.pmprojectspg-inline-13 {\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 24px;\n}\n\n.pmprojectspg-inline-14 {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.pmprojectspg-inline-15 {\n  flex: 1;\n}\n\n.pmprojectspg-inline-16 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.pmprojectspg-inline-17 {\n  font-size: 10px;\n}\n\n.pmprojectspg-inline-18 {\n  font-family: monospace;\n}\n\n.pmprojectspg-inline-19 {\n  font-size: 12px;\n  color: #475569;\n  margin-top: 8px;\n  max-width: 80%;\n}\n\n.pmprojectspg-inline-20 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.pmprojectspg-inline-21 {\n  font-size: 11px;\n  color: #64748b;\n  text-align: right;\n}\n\n.pmprojectspg-inline-22 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pmprojectspg-inline-23 {\n  width: 100px;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.pmprojectspg-inline-24 {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.pmprojectspg-inline-25 {\n  padding: 6px 12px;\n  border-color: #fee2e2;\n  color: #ef4444;\n  background: #fef2f2;\n}\n\n.pmprojectspg-inline-26 {\n  padding: 8px 16px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pmprojectspg-inline-27 {\n  font-weight: 600;\n}\n\n.pmprojectspg-inline-28 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmprojectspg-inline-29 {\n  text-align: center;\n  padding: 24px;\n  color: #94a3b8;\n}\n\n.pmprojectspg-inline-30 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.pmprojectspg-inline-31 {\n  font-weight: 600;\n}\n\n.pmprojectspg-inline-32 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pmprojectspg-inline-33 {\n  width: 60px;\n  height: 5px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.pmprojectspg-inline-34 {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pmprojectspg-inline-35 {\n  display: flex;\n  gap: 4px;\n}\n\n.pmprojectspg-inline-36 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.pmprojectspg-inline-37 {\n  font-size: 10px;\n  padding: 3px 8px;\n  border-color: #fee2e2;\n  color: #ef4444;\n}\n\n.pmprojectspg-inline-38 {\n  padding: 12px 16px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.pmprojectspg-inline-39 {\n  font-size: 12px;\n}\n\n.pmprojectspg-inline-40 {\n  padding: 12px;\n  color: #64748b;\n  font-size: 12px;\n  text-align: center;\n}\n\n.pmprojectspg-inline-41 {\n  margin: 0 auto 10px;\n}\n\n.pmprojectspg-inline-42 {\n  padding: 12px;\n}\n\n.pmprojectspg-inline-43 {\n  font-size: 12px;\n  color: #ef4444;\n  margin-top: 8px;\n  padding: 12px;\n  background: #fef2f2;\n  border-radius: 8px;\n  border: 1px solid #fee2e2;\n}\n\n.pmprojectspg-inline-44 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 8px;\n}\n\n.pmprojectspg-inline-45 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmprojectspg-inline-46 {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.pmprojectspg-inline-47 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprojectspg-inline-48 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprojectspg-inline-49 {\n  padding: 12px;\n  color: #64748b;\n  font-size: 12px;\n  text-align: center;\n}\n\n.pmprojectspg-inline-50 {\n  margin: 0 auto 10px;\n}\n\n.pmprojectspg-inline-51 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #f1f5f9;\n  border-radius: 6px;\n}\n\n.pmprojectspg-inline-52 {\n  font-weight: 600;\n}\n\n.pmprojectspg-inline-53 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmprojectspg-inline-54 {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.pmprojectspg-inline-55 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprojectspg-inline-56 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprojectspg-inline-57 {\n  text-align: center;\n  margin-top: 4px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.pmprojectspg-inline-58 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmprojectspg-inline-59 {\n  margin-bottom: 16px;\n  padding: 16px;\n  background: #fef2f2;\n  border-radius: 8px;\n  border: 1px solid #fee2e2;\n}\n\n.pmprojectspg-inline-60 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.pmprojectspg-inline-61 {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: #fee2e2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ef4444;\n}\n\n.pmprojectspg-inline-62 {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.pmprojectspg-inline-63 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmprojectspg-inline-64 {\n  font-size: 13px;\n  color: #b91c1c;\n  background: #fff;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #fecaca;\n}\n\n.pmprojectspg-inline-65 {\n  margin-top: 8px;\n  margin-bottom: 0;\n  padding-left: 20px;\n}\n\n.pmprojectspg-inline-66 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmprojectspg-inline-67 {\n  background: #ef4444;\n  border-color: #ef4444;\n}\n\n.pmprojectspg-dyn-1 {\n  height: 100%;\n  width: var(--pmprojectspg-1-width);\n  background: var(--pmprojectspg-1-background);\n  border-radius: 4px;\n}\n\n.pmprojectspg-dyn-2 {\n  height: 100%;\n  width: var(--pmprojectspg-2-width);\n  background: var(--pmprojectspg-2-background);\n  border-radius: 4px;\n}\n\n.pmprojectspg-dyn-3 {\n  background: var(--pmprojectspg-3-background);\n  color: var(--pmprojectspg-3-color);\n  border-color: var(--pmprojectspg-3-border-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
